module.exports = __webpack_public_path__ + "img/Shopee.18fce230.png";